<template>
  <list-popover ref="popover" :parent="parent" :direction="direction" :currentValue="attribute.value" align="center" :list="list" @select="selectOption"></list-popover>
</template>

<script>
  import ListPopover from './ListPopover.vue'
  import popoverContainerMixin from './popoverContainerMixin'
  import { cloneDeep } from 'lodash'

  export default {
    mixins: [
      popoverContainerMixin
    ],
    components: {
      ListPopover
    },
    props: {
      parent: {
        type: HTMLElement | SVGElement | SVGUseElement
      },
      direction: {
        type: String,
        default: 'top'
      },
      attribute: {
        type: Object
      }
    },
    computed: {
      list () {
        return this.attribute.options
      }
    },
    methods: {
      selectOption (value) {
        let chosenAttribute = cloneDeep(this.attribute)
        chosenAttribute.value = value
        this.$emit('select', chosenAttribute)
      },
      dismissHandler () {
        this.$emit('dismiss')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectPopover.vue?bd11230e